/**
 * Created by han on 1/23/2019.
 */

export default function development() {
	if ( process.env.NODE_ENV === 'development' ) {
		require( '../../parts/_header.html' );
		require( '../../parts/_footer.html' );
	}
}